import { useState } from "react";
import { SectionCard } from "@/components/common/SectionCard";
import { parseSenseiExportJson, translateSenseiExport } from "@/lib/ops/senseiExport";
import { ghostBtnClass, inputClass, primaryBtnClass } from "./ManufacturingOrderIntakeShared";

export function ManufacturingOrderIntakeSenseiImport(props: {
  busy: boolean;
  error: string | null;
  onSubmit: (payload: unknown) => Promise<boolean>;
  onCancel: () => void;
}) {
  const [text, setText] = useState("");
  const [formError, setFormError] = useState<string | null>(null);

  const preview = (() => {
    const parsed = parseSenseiExportJson(text);
    if (!parsed.ok) return null;
    const t = translateSenseiExport(parsed.payload);
    return t.ok ? t.translation : null;
  })();

  async function submit() {
    setFormError(null);
    const parsed = parseSenseiExportJson(text);
    if (!parsed.ok) {
      setFormError(parsed.error);
      return;
    }
    const t = translateSenseiExport(parsed.payload);
    if (!t.ok) {
      setFormError(t.error);
      return;
    }
    await props.onSubmit(parsed.payload);
  }

  return (
    <SectionCard title="Import Sensei JSON">
      <p className="text-xs text-gray-600 dark:text-zinc-400">
        Paste export JSON as provided. We only read a generic id and customer name — no invented
        Sensei field map until a real payload lands.
      </p>
      <textarea
        className={`${inputClass} mt-2 min-h-[10rem] font-mono text-xs`}
        value={text}
        disabled={props.busy}
        onChange={(e) => setText(e.target.value)}
        placeholder='{"id":"SN-1042","customer":{"name":"…"}}'
      />
      {preview ? (
        <p className="mt-2 text-xs text-gray-600">
          Will import <span className="font-medium">{preview.external_source_id}</span>
          {preview.customer_display_name ? ` · ${preview.customer_display_name}` : ""} · {preview.kind}
        </p>
      ) : null}
      {formError || props.error ? (
        <p className="mt-2 text-sm text-rose-800">{formError || props.error}</p>
      ) : null}
      <div className="mt-3 flex flex-wrap gap-2">
        <button type="button" className={primaryBtnClass} disabled={props.busy} onClick={() => void submit()}>
          Import to review queue
        </button>
        <button type="button" className={ghostBtnClass} disabled={props.busy} onClick={props.onCancel}>
          Cancel
        </button>
      </div>
    </SectionCard>
  );
}
